export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATE_BLANK.0843d46c.png";